import { useApi } from '@omnipresentgroup/api';
import { notifyError, notifySuccess } from '@omnipresentgroup/design-system';
import type { UpdateTimesheetRequest } from '@omnipresentgroup/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useUpdateTimesheetMutation = (timesheetId: string) => {
  const { PATCH } = useApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateTimesheetRequest) => {
      return PATCH({
        path: `${API_BASE}/${API_PATH}/${timesheetId}`,
        body: payload,
      });
    },
    onError(error) {
      (error as Error).message &&
        notifyError({
          title: 'Error',
          description: (error as Error).message,
        });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_PATH],
      });
      notifySuccess({
        title: 'Success',
        description:
          'Your timesheet has been saved. Please submit for approval when completed.',
      });
    },
  });
};
